import { render, staticRenderFns } from "./ModulosComplementares.vue?vue&type=template&id=41ded7d2"
import script from "./ModulosComplementares.vue?vue&type=script&lang=ts"
export * from "./ModulosComplementares.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports